import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/views/Home.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('@/views/Contact.vue')
    },
    {
      path: '/field-notes',
      name: 'field-notes',
      component: () => import('@/views/FieldNotes.vue')
    },
    {
      path: '/time-entry',
      name: 'time-entry',
      component: () => import('@/views/TimeEntry.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/expenses',
      name: 'expenses',
      component: () => import('@/views/Expenses.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/bank-reconciliation',
      name: 'bank-reconciliation',
      component: () => import('@/views/BankReconciliation.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/expense-entry',
      name: 'expense-entry',
      component: () => import('@/views/ExpenseEntry.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/expense-sheet',
      name: 'expense-sheet',
      component: () => import('@/views/ExpenseSheet.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/unbillable-entry',
      name: 'unbillable-entry',
      component: () => import('@/views/UnbillableEntry.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/tax-calculator',
      name: 'tax-calculator',
      component: () => import('@/views/TaxCalculator.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/time-log',
      name: 'time-log',
      component: () => import('@/views/TimeLog.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/invoices',
      name: 'invoices',
      component: () => import('@/views/Invoices.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/invoices/:id',
      name: 'invoice-detail',
      component: () => import('@/views/InvoiceDetail.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/clients',
      name: 'clients',
      component: () => import('@/views/Clients.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: () => import('@/views/Dashboard.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/business-calculations',
      name: 'business-calculations',
      component: () => import('@/views/BusinessCalculations.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/fsu-projects',
      name: 'fsu-projects',
      component: () => import('@/views/FSUProjects.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/ops',
      name: 'ops',
      component: () => import('@/views/Ops.vue'),
      meta: { requiresAuth: true }
    }
  ]
})

// No route guard needed - Cloudflare Access handles authentication
// The frontend loads normally, and API calls will trigger Cloudflare Access login if needed
export default router
